module.exports = __webpack_public_path__ + "img/kr-product-content2-img-2.05801f1.png";